export default __webpack_public_path__ + "static/media/Handle_DHP180.a7a997b6.obj";